import { ReactNode, useEffect, useRef, useState } from "react";
import "./styles.css";

export type Side = "top" | "bottom" | "left" | "right";

interface TooltipProps {
  children: ReactNode;
}

interface TooltipTriggerProps {
  children: ReactNode;
  className?: string;
}

interface TooltipContentProps {
  children: ReactNode;
  className?: string;
  side?: Side;
  style?: React.CSSProperties;
}

const ToolTip = ({ children }: TooltipProps) => {
  return <div className="tooltip-container">{children}</div>;
};

const ToolTipTrigger = ({ children, className }: TooltipTriggerProps) => {
  return <div className={`tooltip-trigger ${className || ""}`}>{children}</div>;
};

const ToolTipArrow = ({
  side = "top",
  className = "",
}: {
  side?: Side;
  className?: string;
}) => {
  return <div className={`tooltip-arrow tooltip-arrow-${side} ${className}`} />;
};

const ToolTipContent = ({
  children,
  className,
  side = "top",
  style,
}: TooltipContentProps) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const trigger = contentRef.current?.previousElementSibling as HTMLElement;
    if (!trigger) return;

    const show = () => setVisible(true);
    const hide = () => setVisible(false);

    trigger.addEventListener("mouseenter", show);
    trigger.addEventListener("mouseleave", hide);

    return () => {
      trigger.removeEventListener("mouseenter", show);
      trigger.removeEventListener("mouseleave", hide);
    };
  }, []);

  return (
    <div
      style={style}
      ref={contentRef}
      className={`tooltip-content tooltip-${side} ${visible ? "visible" : ""} ${
        className || ""
      }`}
    >
      {children}
    </div>
  );
};

ToolTip.Trigger = ToolTipTrigger;
ToolTip.Content = ToolTipContent;
ToolTip.Arrow = ToolTipArrow;

export default ToolTip;
